<template>
  <div>
    <!-- 分批付款 -->
    <el-dialog :title="$t('message.partialRemittance')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1288px" center>
      <div class="content">
        <!-- 订单总计 -->
        <div class="block-item">
          <h6>订单总计</h6>
          <ul style="background-color: rgba(217, 240, 249, 0.847058823529412);">
            <!-- 商品金额： -->
            <li>
              <div class="item">{{ $t("message.goodsAmount") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(total.goodsAmount) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen((total.goodsAmount * rate)) }} 円</div>
            </li>
            <!-- 国内运费 -->
            <li>
              <div class="item">{{ $t("message.domesticFreight") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(total.domesticFreight) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(total.domesticFreight * rate) }} 円</div>
            </li>
            <!-- 手续费 -->
            <li>
              <div class="item">{{ $t("message.poundage") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(poundage) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(poundage * rate) }} 円</div>
            </li>
            <!-- 附加服务费 -->
            <li>
              <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
              <!-- 人民币 -->
              <div class="item"> {{ formatRmb(total.additionalServiceCharge) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(total.additionalServiceCharge * rate) }} 円</div>
            </li>
            <!-- 其他费用： -->
            <li>
              <div class="item">{{ $t("message.otherFees") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(detail.other_price) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(detail.other_price * rate) }} 円</div>
            </li>
            <!-- 合计 -->
            <li>
              <div class="item">{{ $t("message.total") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(domesticSubtotal) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(domesticSubtotal * rate) }} 円</div>
            </li>
          </ul>
        </div>
        <!-- 支付金额设定 -->
        <div class="block-item">
          <h6>{{ $t('message.paymentAmountSetting') }}
            <!-- 首付款比例 -->
            <el-select v-model="datas.first_payment_ratio" placeholder="请选择首付款比例" @change="onRatioChange"
              style="width: 150px; margin-right: 20px;" size="small">
              <el-option v-for="ratio in ratioOptions" :key="ratio" :label="ratio + '%'" :value="ratio"></el-option>
            </el-select>
          </h6>
          <ul>
            <!-- 商品金额： -->
            <li>
              <div class="item">{{ $t("message.goodsAmount") }}</div>
              <!-- 人民币 -->
              <div class="item2">
                <el-input v-model="datas.goods_amount" size="small" placeholder="请输入具体金额" type="number"
                  @input="onGoodsAmountInput" disabled></el-input>
              </div>
            </li>
            <!-- 国内运费 -->
            <li>
              <div class="item">{{ $t("message.domesticFreight") }}</div>
              <!-- 付首款时付 -->
              <div class="item"> <el-radio :label="1" v-model="datas.is_pay_freight_amount" @change="computeKin">{{
                $t('message.payOnFirstPayment') }}</el-radio></div>
              <!-- 与尾款一起支付 -->
              <div class="item"> <el-radio :label="0" v-model="datas.is_pay_freight_amount" @change="computeKin">{{
                $t('message.payWithTheBalance') }}</el-radio></div>
            </li>
            <!-- 手续费 -->
            <li>
              <div class="item">{{ $t("message.poundage") }}</div>
              <!-- 付首款时付 -->
              <div class="item"> <el-radio :label="1" v-model="datas.is_pay_service_amount" @change="computeKin">{{
                $t('message.payOnFirstPayment') }}</el-radio></div>
              <!-- 与尾款一起支付 -->
              <div class="item"> <el-radio :label="0" v-model="datas.is_pay_service_amount" @change="computeKin">{{
                $t('message.payWithTheBalance') }}</el-radio></div>
            </li>
            <!-- 附加服务费 -->
            <li>
              <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
              <div class="item"> <el-radio :label="1" v-model="datas.is_pay_option_amount" @change="computeKin">{{
                $t('message.payOnFirstPayment') }}</el-radio></div>
              <!-- 与尾款一起支付 -->
              <div class="item"> <el-radio :label="0" v-model="datas.is_pay_option_amount" @change="computeKin">{{
                $t('message.payWithTheBalance') }}</el-radio></div>
            </li>
            <!-- 其他费用： -->
            <li>
              <div class="item">{{ $t("message.otherFees") }}</div>
              <div class="item"> <el-radio :label="1" v-model="datas.is_pay_other_amount" @change="computeKin">{{
                $t('message.payOnFirstPayment') }}</el-radio></div>
              <!-- 与尾款一起支付 -->
              <div class="item"> <el-radio :label="0" v-model="datas.is_pay_other_amount" @change="computeKin"
                  disabled>{{
                    $t('message.payWithTheBalance') }}</el-radio></div>
            </li>
            <!-- 尾款支付节点： -->
            <li>
              <div class="item">{{ $t("message.finalPaymentNode") }}</div>
              <!-- 上架仓库前 -->
              <div class="item"> <el-radio :label="1" v-model="datas.must_pay_node">{{
                $t('message.preWarehouse') }}</el-radio></div>
              <!-- 提配送单前 -->
              <div class="item"> <el-radio :label="2" v-model="datas.must_pay_node">{{
                $t('message.beforeDeliveryOrder') }}</el-radio></div>
            </li>
          </ul>
        </div>
        <!-- 首款 -->
        <div class="block-item">
          <h6>{{ $t('message.theFirst') }}</h6>
          <ul style="background-color: rgba(251, 228, 230);">
            <!-- 商品金额： -->
            <li>
              <div class="item">{{ $t("message.goodsAmount") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.goods_amount) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen((firstKin.goods_amount * rate)) }} 円</div>
            </li>
            <!-- 国内运费 -->
            <li>
              <div class="item">{{ $t("message.domesticFreight") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.freight_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(firstKin.freight_amount * rate) }} 円</div>
            </li>
            <!-- 手续费 -->
            <li>
              <div class="item">{{ $t("message.poundage") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.service_amount) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(firstKin.service_amount * rate) }} 円</div>
            </li>
            <!-- 附加服务费 -->
            <li>
              <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.option_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(firstKin.option_amount * rate) }} 円</div>
            </li>
            <!-- 其他费用： -->
            <li>
              <div class="item">{{ $t("message.otherFees") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.other_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(firstKin.other_amount * rate) }} 円</div>
            </li>

            <!-- 合计 -->
            <li>
              <div class="item">{{ $t("message.total") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(firstKin.total) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(firstKin.total * rate) }} 円</div>
            </li>
          </ul>
        </div>
        <!-- 尾款 -->
        <div class="block-item">
          <h6>{{ $t('message.balancePayment') }}</h6>
          <ul style="background-color: rgba(250, 205, 145);">
            <!-- 商品金额： -->
            <li>
              <div class="item">{{ $t("message.goodsAmount") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.goods_amount) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen((lastKin.goods_amount * rate)) }} 円</div>
            </li>
            <!-- 国内运费 -->
            <li>
              <div class="item">{{ $t("message.domesticFreight") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.freight_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(lastKin.freight_amount * rate) }} 円</div>
            </li>
            <!-- 手续费 -->
            <li>
              <div class="item">{{ $t("message.poundage") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.service_amount) }} 元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(lastKin.service_amount * rate) }} 円</div>
            </li>
            <!-- 附加服务费 -->
            <li>
              <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.option_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(lastKin.option_amount * rate) }} 円</div>
            </li>
            <!-- 其他费用： -->
            <li>
              <div class="item">{{ $t("message.otherFees") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.other_amount) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(lastKin.other_amount * rate) }} 円</div>
            </li>

            <!-- 合计 -->
            <li>
              <div class="item">{{ $t("message.total") }}</div>
              <!-- 人民币 -->
              <div class="item">{{ formatRmb(lastKin.total) }}元</div>
              <!-- 日元 -->
              <div class="item"> {{ ceilYen(lastKin.total * rate) }} 円</div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.addExpressDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NP from 'number-precision'
export default {
  props: {
    total: { type: Object },
  },
  computed: {
    ...mapState({
      detail: (state) => state.orderDetail.detail,
      logisticsList: (state) => state.porderDetail.logisticsList,
      rate: (state) => state.rate,
    }),
    // 国内小计
    domesticSubtotal() {
      let num = 0
      num = (
        this.total.goodsAmount -
        0 +
        (this.total.domesticFreight - 0) +
        (this.poundage - 0) +
        (this.total.additionalServiceCharge - 0) +
        (this.detail.other_price - 0)
      );
      return NP.strip(num)
    },
    // 手续费 单番手续费
    poundage() {
      let num = 0
      this.detail.order_detail.forEach((item) => {
        if (this.status == 20) {
          num += NP.strip(item.price * item.num * item.service_rate)
        } else if (this.status == 21) {
          num += NP.strip(item.confirm_num * item.confirm_price * item.service_rate)
        } else {

          num += NP.strip(item.offer_price * item.offer_num * item.service_rate)
        }
      })

      return this.roundRmb(NP.strip(num));
    },
    // 国际物流
    logistics() {
      let logisticsList = JSON.parse(JSON.stringify(this.logisticsList))
      // logisticsList.forEach(item => {
      //   this.logisticsFreight.forEach(items => {
      //     if (item.id == items.logistics_id) {
      //       item.name = item.name + ` ` + (items.total_money_rmb * this.rate).toFixed(0) + '円'
      //     }
      //   })
      // })
      return logisticsList
    },
    // 百分比选项（1-100，5的倍数）
    ratioOptions() {
      let options = []
      for (let i = 0; i <= 100; i += 5) {
        options.push(i)
      }
      return options
    },

  },
  data() {
    return {
      datas: {
        preview: 0,
        order_sn: this.$route.query.order_sn,
        goods_amount: 0,
        is_pay_freight_amount: 1,
        is_pay_option_amount: 1,
        is_pay_service_amount: 1,
        is_pay_other_amount: 1,
        must_pay_node: 1,
        first_payment_ratio: '',
      },
      firstKin: {
        goods_amount: 0,
        freight_amount: 0,
        option_amount: 0,
        service_amount: 0,
        other_amount: 0,
        total: 0,
      },//首款
      lastKin: {
        goods_amount: 0,
        freight_amount: 0,
        option_amount: 0,
        service_amount: 0,
        other_amount: 0,
        total: 0,
      },//尾款
      dialogVisible: false,
      manualInput: false // 标记是否手动输入了金额
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.manualInput = false
        if (this.detail.order_part_pay != false) {
          let order_part_pay = JSON.parse(JSON.stringify(this.detail.order_part_pay))
          this.firstKin = order_part_pay[0]
          this.lastKin = order_part_pay[1]
          this.datas = {
            preview: 0,
            order_sn: this.$route.query.order_sn,
            goods_amount: this.firstKin.goods_amount,
            is_pay_freight_amount: this.firstKin.is_pay_freight_amount,
            is_pay_option_amount: this.firstKin.is_pay_option_amount,
            is_pay_service_amount: this.firstKin.is_pay_service_amount,
            is_pay_other_amount: this.firstKin.is_pay_other_amount,
            must_pay_node: this.firstKin.must_pay_node ? this.firstKin.must_pay_node : this.lastKin.must_pay_node,
            first_payment_ratio: this.firstKin.first_payment_goods_ratio,
          }
          this.computeKin()
        } else {
          // 首次打开，默认50%
          // this.datas.first_payment_ratio = 50
          this.calculateGoodsAmountByRatio()
        }
      }
    }
  },
  methods: {
    // 保存
    save() {
      this.$api.orderApi.updateOrderPartPayPlan(this.datas).then(res => {
        this.detail.order_part_pay = res.data
        this.$message.success(res.msg)
        this.dialogVisible = false
      })
    },
    // 计算金额
    computeKin() {
      if (this.datas.goods_amount > this.total.goodsAmount) {
        this.datas.goods_amount = NP.strip(this.total.goodsAmount)
      }
      // 商品金额
      this.firstKin.goods_amount = this.datas.goods_amount
      this.lastKin.goods_amount = this.total.goodsAmount - this.firstKin.goods_amount
      // 国内运费
      if (this.datas.is_pay_freight_amount) {
        this.firstKin.freight_amount = this.total.domesticFreight
        this.lastKin.freight_amount = 0
      } else {
        this.lastKin.freight_amount = this.total.domesticFreight
        this.firstKin.freight_amount = 0
      }
      // 手续费
      if (this.datas.is_pay_service_amount) {
        this.firstKin.service_amount = this.poundage
        this.lastKin.service_amount = 0
      } else {
        this.lastKin.service_amount = this.poundage
        this.firstKin.service_amount = 0
      }
      // 附加服务
      if (this.datas.is_pay_option_amount) {
        this.firstKin.option_amount = this.total.additionalServiceCharge
        this.lastKin.option_amount = 0
      } else {
        this.lastKin.option_amount = this.total.additionalServiceCharge
        this.firstKin.option_amount = 0
      }
      // 其他费用
      if (this.datas.is_pay_other_amount) {
        this.firstKin.other_amount = this.detail.other_price
        this.lastKin.other_amount = 0
      } else {
        this.lastKin.other_amount = this.detail.other_price
        this.firstKin.other_amount = 0
      }

      this.lastKin.must_pay_node = this.datas.must_pay_node
      this.lastKin.total = (this.lastKin.other_amount - 0) + (this.lastKin.option_amount - 0) + (this.lastKin.service_amount - 0) + (this.lastKin.freight_amount - 0) + (this.lastKin.goods_amount - 0)
      this.firstKin.total = (this.firstKin.other_amount - 0) + (this.firstKin.option_amount - 0) + (this.firstKin.service_amount - 0) + (this.firstKin.freight_amount - 0) + (this.firstKin.goods_amount - 0)

      this.$forceUpdate()

    },
    // 百分比变化时自动计算商品金额
    onRatioChange() {
      if (this.datas.first_payment_ratio) {
        this.calculateGoodsAmountByRatio()
      }
    },
    // 根据百分比计算商品金额（向上取整）
    calculateGoodsAmountByRatio() {
      if (this.datas.first_payment_ratio) {
        const ratio = this.datas.first_payment_ratio / 100
        const amount = (this.total.goodsAmount * ratio).toFixed(2)
        this.datas.goods_amount = amount
        this.computeKin()
      }
    },
    // 手动输入金额时标记
    onGoodsAmountInput() {
      this.manualInput = true
      // 清空百分比选择，因为用户手动输入了金额
      this.datas.first_payment_ratio = ''
      this.computeKin()
    },
    // 人民币四舍五入保留两位小数
    roundRmb(num) {
      const value = Number(num) || 0
      return Math.round((value + Number.EPSILON) * 100) / 100
    },
    formatRmb(num) {
      return this.roundRmb(num).toFixed(2)
    },
    // 日元向上取整
    ceilYen(num) {
      return Math.ceil(num)
    }
  },
};
</script>
<style lang='scss' scoped>
.content {

  display: flex;
  flex-wrap: wrap;

  .block-item {
    width: 600px;
    margin-bottom: 38px;


    &:nth-child(odd) {
      margin-right: 38px;
    }

    h6 {
      font-size: 20px;
      font-weight: 600;
      color: #B4272D;
      margin-bottom: 20px;
      line-height: 32px;
    }

    ul {
      border: 1px solid #ccc;

      li {
        display: flex;
        border-bottom: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }

        .item {
          flex: 1;
          border-right: 1px solid #ccc;
          padding: 10px;

          &:nth-last-child(1) {
            border: 0;
          }
        }

        .item2 {
          flex: 2;
          padding: 5px 20px;

        }
      }
    }

    // background-color: pink;
  }
}

/deep/.el-dialog {
  margin-top: 20px !important;
}
</style>
